import * as React from "react";
const SvgLight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M257.894 156.948c-53.258 0-96.42 43.561-96.42 97.26 0 53.719 43.161 97.249 96.42 97.249 53.197 0 96.379-43.53 96.379-97.25 0-53.698-43.182-97.26-96.379-97.26zm0 152.925c-30.464 0-55.163-24.945-55.163-55.665s24.699-55.624 55.163-55.624c30.423 0 55.101 24.904 55.101 55.624s-24.688 55.665-55.101 55.665M241.808 43.499h32.144v79.575h-32.144zM417.209 115.897 394.486 92.98l-55.757 56.279 22.723 22.907zM389.468 238.407h78.899v32.389h-78.899zM396.012 416.86l22.723-22.917-55.767-56.259-22.712 22.897zM242.473 388.915h32.144v79.575h-32.144zM96.266 396.073l22.722 22.938 55.778-56.289-22.692-22.928zM43.633 240.537h78.879v32.43H43.633zM115.394 93.051l-22.681 22.907 55.757 56.258 22.702-22.917z" />
  </svg>
);
export default SvgLight;
